(function () {
  function applyOverrides() {
    var bg = document.getElementById('epb_background');
    if (bg) bg.style.setProperty('z-index', '2', 'important');

    var drawer = document.querySelector('.menu-drawer');
    if (drawer) drawer.style.setProperty('z-index', '100', 'important');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOverrides);
  } else {
    applyOverrides();
  }

  // App embeds and inline styles can land late — re-apply a few times.
  setTimeout(applyOverrides, 500);
  setTimeout(applyOverrides, 1500);
  setTimeout(applyOverrides, 3000);
  window.addEventListener('load', applyOverrides);

  // Re-apply when the drawer is toggled, in case the app re-sets its style.
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.header__icon--menu, .menu-drawer__close-button, .menu-drawer__backdrop')) {
      setTimeout(applyOverrides, 50);
      setTimeout(applyOverrides, 300);
    }
  });

  // Catch any future inline-style mutations on these elements.
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(applyOverrides);
    var start = function () {
      document.querySelectorAll('#epb_background, .menu-drawer').forEach(function (el) {
        observer.observe(el, { attributes: true, attributeFilter: ['style'] });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }
})();
